import React, { Component } from 'react';
import '../index.css';
function LeftTab(props) {
  const url = props.url;
  return (
    <div style={{ paddingTop: 108 }}>
      <div className={url === '/signup/privacy' ? 'tab-selected' : 'tab'}>
        <img src={'/icons/ic-sign-up-no1.png'} alt="no1" />
        <p>개인정보</p>
      </div>
      <div className={url === '/signup/terms' ? 'tab-selected' : 'tab'}>
        <img src={'/icons/ic-sign-up-no2.png'} alt="no2" />
        <p>약관동의</p>
      </div>
      <div className={url === '/signup/account' ? 'tab-selected' : 'tab'}>
        <img src={'/icons/ic-sign-up-no3.png'} alt="no3" />
        <p>계정연동</p>
      </div>

      <div className={url === '/signup/select-shop' ? 'tab-selected' : 'tab'}>
        <img src={'/icons/ic-sign-up-no4.png'} alt="no4" />
        <p>쇼핑몰 선택</p>
      </div>
      <div className={url === '/signup/complete' ? 'tab-selected' : 'tab'}>
        <img src={'/icons/ic-sign-up-no5.png'} alt="no5" />
        <p>가입완료</p>
      </div>
    </div>
  );
}

export default LeftTab;
